(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-blog-more]') : null;
    if (!btn) return;
    var url = btn.getAttribute('data-next-url');
    if (!url) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-loading') || 'Chargement…';
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.blog-grid__grid');
        var grid = document.querySelector('.blog-grid__grid');
        if (newGrid && grid) {
          Array.prototype.forEach.call(newGrid.querySelectorAll('.blog-grid__card'), function (c) { grid.appendChild(c); });
        }
        var nextBtn = doc.querySelector('[data-blog-more]');
        var nextUrl = nextBtn && nextBtn.getAttribute('data-next-url');
        if (nextUrl) {
          btn.setAttribute('data-next-url', nextUrl);
          btn.disabled = false;
          btn.textContent = label;
        } else {
          btn.remove();
        }
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function secId(el) {
      var s = el && el.closest ? el.closest('.shopify-section') : null;
      return s ? s.id.replace('shopify-section-', '') : null;
    }
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('ccs__form')) return;
      var wrap = form.closest('[data-cart-add-url]');
      if (!wrap) return;
      e.preventDefault();
      var addUrl = wrap.getAttribute('data-cart-add-url') || '/cart/add';
      var cartUrl = wrap.getAttribute('data-cart-url') || '/cart';
      var xsId = wrap.getAttribute('data-section-id');
      var itemsSec = secId(document.querySelector('cart-items'));
      var footerEl = document.querySelector('.cart__footer');
      var footerSec = footerEl ? secId(footerEl) : null;
      var ids = [xsId, itemsSec, footerSec].filter(Boolean);
      var btn = form.querySelector('button[type="submit"]');
      var fd = new FormData(form);
      fd.append('sections', ids.join(','));
      fd.append('sections_url', cartUrl);
      if (btn) btn.setAttribute('disabled', '');
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (btn) btn.removeAttribute('disabled');
          if (res.status) { window.location = cartUrl; return; }
          if (res.sections) {
            ids.forEach(function (id) {
              var el = document.getElementById('shopify-section-' + id);
              if (el && res.sections[id] != null) el.innerHTML = res.sections[id];
            });
          } else {
            window.location = cartUrl;
          }
        })
        .catch(function () { if (btn) btn.removeAttribute('disabled'); window.location = cartUrl; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-packs"]) return;
  try {
    
  (function () {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('colp__form')) return;
      var wrap = form.closest('[data-cart-add-url]');
      var addUrl = wrap ? wrap.getAttribute('data-cart-add-url') : '/cart/add';
      var cartUrl = wrap ? wrap.getAttribute('data-cart-url') : '/cart';
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var fd = new FormData(form);
      try {
        var ids = drawer.getSectionsToRender().map(function (s) { return s.section; });
        fd.append('sections', ids.join(','));
        fd.append('sections_url', window.location.pathname);
      } catch (err) {}
      if (btn) btn.setAttribute('disabled', '');
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (btn) btn.removeAttribute('disabled');
          if (res.status) { window.location = cartUrl; return; }
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(function () { if (btn) btn.removeAttribute('disabled'); window.location = cartUrl; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function nextTarget(hour, minute) {
      var now = new Date();
      var target = new Date(now);
      target.setHours(hour, minute, 0, 0);
      if (target.getTime() <= now.getTime()) {
        target.setDate(target.getDate() + 1);
      }
      return target;
    }

    function initTimer(el) {
      if (el.dataset.countdownReady === 'true') return;
      el.dataset.countdownReady = 'true';

      var hour = parseInt(el.getAttribute('data-hour'), 10) || 0;
      var minute = parseInt(el.getAttribute('data-minute'), 10) || 0;
      var showSeconds = el.getAttribute('data-seconds') === 'true';

      var hoursEl = el.querySelector('[data-hours]');
      var minutesEl = el.querySelector('[data-minutes]');
      var secondsEl = el.querySelector('[data-seconds-num]');

      var target = nextTarget(hour, minute);

      function render() {
        var now = Date.now();
        var diff = target.getTime() - now;
        if (diff <= 0) {
          target = nextTarget(hour, minute);
          diff = target.getTime() - now;
        }
        var totalSeconds = Math.floor(diff / 1000);
        var h = Math.floor(totalSeconds / 3600);
        var m = Math.floor((totalSeconds % 3600) / 60);
        var s = totalSeconds % 60;

        if (hoursEl) hoursEl.textContent = pad(h);
        if (minutesEl) minutesEl.textContent = pad(m);
        if (showSeconds && secondsEl) secondsEl.textContent = pad(s);
      }

      render();
      var interval = setInterval(render, 1000);

      // Nettoyage si la section est retirée dans l'éditeur de thème.
      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target && event.target.contains(el)) {
          clearInterval(interval);
        }
      });
    }

    function initAll(root) {
      var scope = root || document;
      var timers = scope.querySelectorAll('[data-countdown]');
      for (var i = 0; i < timers.length; i++) {
        initTimer(timers[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    // Rechargement d'une section dans l'éditeur de thème.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog-simple"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Boucle infinie calquée sur la section avant/après (sans auto-défilement).
    function initCarousel(root) {
      if (root.dataset.jrnReady === 'true') return;
      root.dataset.jrnReady = 'true';

      var track = root.querySelector('[data-jrn-track]');
      if (!track) return;
      var prev = root.querySelector('[data-jrn-prev]');
      var next = root.querySelector('[data-jrn-next]');

      function step() {
        var card = track.querySelector('.jrn__item');
        if (!card) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      var host = root.closest('.jrn');
      var stacked = host && host.classList.contains('jrn--stacked');

      if (!stacked) {
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        return;
      }

      var PEEK = 15;
      // Boucle infinie : on duplique les cartes une seule fois
      var loopW = 0;
      (function setupLoop() {
        if (track.scrollWidth <= track.clientWidth + 2) return;
        var kids = Array.prototype.slice.call(track.children);
        for (var i = 0; i < kids.length; i++) {
          var c = kids[i].cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.classList.add('jrn-clone');
          track.appendChild(c);
        }
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        loopW = track.scrollWidth / 2;
        var first = track.querySelector('.jrn__item');
        var w = first ? first.getBoundingClientRect().width : 0;
        track.scrollLeft = Math.max(0, Math.round(w - PEEK));
      })();
      window.addEventListener('load', function () { if (loopW > 0) { loopW = track.scrollWidth / 2; } }, { passive: true });

      function wrap() {
        if (loopW <= 0) return;
        if (track.scrollLeft >= loopW) { track.scrollLeft = track.scrollLeft - loopW; }
        else if (track.scrollLeft < 0) { track.scrollLeft = track.scrollLeft + loopW; }
      }

      if (prev) prev.addEventListener('click', function () {
        if (loopW > 0 && track.scrollLeft < step() + 4) { track.scrollLeft += loopW; }
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      var wrapT = null;
      track.addEventListener('scroll', function () {
        if (wrapT) return;
        wrapT = setTimeout(function () { wrapT = null; wrap(); }, 130);
      }, { passive: true });
    }

    function initAll(root) {
      var scope = root || document;
      var c = scope.querySelectorAll('[data-jrn]');
      for (var i = 0; i < c.length; i++) { initCarousel(c[i]); }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-simple"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.fpsReady === 'true') return;
      root.dataset.fpsReady = 'true';
      var track = root.querySelector('[data-fps-track]');
      var prev = root.querySelector('[data-fps-prev]');
      var next = root.querySelector('[data-fps-next]');
      if (!track) return;
      function step() {
        var it = track.querySelector('.fps__item');
        if (!it) return track.clientWidth;
        var st = window.getComputedStyle(track);
        var gap = parseFloat(st.columnGap || st.gap || '0') || 0;
        return it.getBoundingClientRect().width + gap;
      }

      // Centrer les flèches verticalement sur l'IMAGE (et non sur toute la carte)
      function placeArrows() {
        var m = track.querySelector('.fps__media');
        if (!m) return;
        var h = m.getBoundingClientRect().height;
        if (h > 0) {
          if (prev) prev.style.top = Math.round(h / 2) + 'px';
          if (next) next.style.top = Math.round(h / 2) + 'px';
        }
      }
      placeArrows();
      if ('requestAnimationFrame' in window) requestAnimationFrame(placeArrows);
      setTimeout(placeArrows, 300); setTimeout(placeArrows, 900);
      window.addEventListener('load', placeArrows, { passive: true });
      window.addEventListener('resize', placeArrows, { passive: true });

      // Flèches ordinateur : désactivées aux extrémités (pas de boucle).
      function update() {
        if (loopW > 0 || !prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= max;
      }

      // Boucle infinie mobile : clones ajoutés/retirés selon la largeur d'écran.
      var loopW = 0;
      function enableLoop() {
        if (loopW > 0 || track.querySelector('.fps-clone')) return;
        if (track.scrollWidth <= track.clientWidth + 2) return;
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
        var kids = Array.prototype.slice.call(track.children);
        for (var i = 0; i < kids.length; i++) {
          var c = kids[i].cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.classList.add('fps-clone');
          track.appendChild(c);
        }
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        loopW = track.scrollWidth / 2;
        // Mobile : repos décalé (filet du produit précédent visible). Desktop : démarre sur le 1er produit.
        var c0 = track.querySelector('.fps__item');
        if (c0 && window.matchMedia('(max-width: 749px)').matches) { var pw = c0.getBoundingClientRect().width; track.scrollLeft = Math.max(0, Math.round(pw - 15)); }
      }
      function disableLoop() {
        var clones = track.querySelectorAll('.fps-clone');
        for (var i = 0; i < clones.length; i++) { clones[i].parentNode.removeChild(clones[i]); }
        loopW = 0;
        track.style.scrollSnapType = '';
        track.style.scrollBehavior = '';
        track.scrollLeft = 0;
      }
      function wrap() {
        if (loopW <= 0) return;
        if (track.scrollLeft >= loopW) { track.scrollLeft = track.scrollLeft - loopW; }
        else if (track.scrollLeft < 0) { track.scrollLeft = track.scrollLeft + loopW; }
      }

      if (prev) prev.addEventListener('click', function () {
        if (loopW > 0 && track.scrollLeft < step() + 4) { track.scrollLeft += loopW; }
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      var wrapT = null;
      track.addEventListener('scroll', function () {
        if (loopW > 0) {
          if (wrapT) return;
          wrapT = setTimeout(function () { wrapT = null; wrap(); }, 130);
        } else {
          update();
        }
      }, { passive: true });

      var mq = window.matchMedia('(max-width: 749px)');
      function applyMode() {
        // Boucle infinie des deux côtés dès qu'il y a débordement horizontal (mobile ET carrousel desktop)
        if (track.scrollWidth > track.clientWidth + 2) { enableLoop(); }
        else { disableLoop(); update(); }
      }
      if (mq.addEventListener) { mq.addEventListener('change', applyMode); }
      else if (mq.addListener) { mq.addListener(applyMode); }
      window.addEventListener('load', function () { if (loopW > 0) { loopW = track.scrollWidth / 2; } else { applyMode(); } }, { passive: true });
      var _fpsRt; window.addEventListener('resize', function () { clearTimeout(_fpsRt); _fpsRt = setTimeout(function () { if (loopW > 0) { loopW = track.scrollWidth / 2; } else { applyMode(); } }, 200); }, { passive: true });
      applyMode();
    }
    function initAll(root) {
      var scope = root || document;
      var els = scope.querySelectorAll('[data-fps]');
      for (var i = 0; i < els.length; i++) init(els[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  // Ajout au panier AJAX -> ouvre le tiroir latéral Dawn (si activé)
  (function () {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('fps__form')) return;
      var wrap = form.closest('[data-cart-add-url]');
      var addUrl = wrap ? wrap.getAttribute('data-cart-add-url') : '/cart/add';
      var cartUrl = wrap ? wrap.getAttribute('data-cart-url') : '/cart';
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return; // pas de tiroir -> submit normal
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var fd = new FormData(form);
      try {
        var ids = drawer.getSectionsToRender().map(function (s) { return s.section; });
        fd.append('sections', ids.join(','));
        fd.append('sections_url', window.location.pathname);
      } catch (err) {}
      if (btn) btn.setAttribute('disabled', '');
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (btn) btn.removeAttribute('disabled');
          if (res.status) { window.location = cartUrl; return; }
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(function () { if (btn) btn.removeAttribute('disabled'); window.location = cartUrl; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-autres-produits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.apReady === 'true') return;
      root.dataset.apReady = 'true';
      var track = root.querySelector('[data-ap-track]');
      var prev = root.querySelector('[data-ap-prev]');
      var next = root.querySelector('[data-ap-next]');
      if (!track) return;
      function step() {
        var it = track.querySelector('.ap-item');
        if (!it) return track.clientWidth;
        var st = window.getComputedStyle(track);
        var gap = parseFloat(st.columnGap || st.gap || '0') || 0;
        return it.getBoundingClientRect().width + gap;
      }
      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        var noScroll = track.scrollWidth <= track.clientWidth + 2;
        prev.disabled = noScroll || track.scrollLeft <= 0;
        next.disabled = noScroll || track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      // Mobile : démarrer centré sur la 2e carte -> aperçu d'un produit à gauche ET à droite dès l'arrivée
      function centerStart() {
        if (window.innerWidth >= 750) return;
        var items = track.querySelectorAll('.ap-item');
        if (items.length < 2) return;
        var c = items[1];
        track.scrollLeft = c.offsetLeft - (track.clientWidth - c.clientWidth) / 2;
      }
      requestAnimationFrame(centerStart);
      update();
    }
    function initAll(scope) {
      var els = (scope || document).querySelectorAll('[data-ap]');
      for (var i = 0; i < els.length; i++) init(els[i]);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
    else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  // Ajout au panier AJAX -> ouvre le tiroir latéral Dawn (si activé)
  (function () {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('ap-form')) return;
      var wrap = form.closest('[data-cart-add-url]');
      var addUrl = wrap ? wrap.getAttribute('data-cart-add-url') : '/cart/add';
      var cartUrl = wrap ? wrap.getAttribute('data-cart-url') : '/cart';
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return; // pas de tiroir -> submit normal
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var fd = new FormData(form);
      try {
        var ids = drawer.getSectionsToRender().map(function (s) { return s.section; });
        fd.append('sections', ids.join(','));
        fd.append('sections_url', window.location.pathname);
      } catch (err) {}
      if (btn) btn.setAttribute('disabled', '');
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (btn) btn.removeAttribute('disabled');
          if (res.status) { window.location = cartUrl; return; }
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(function () { if (btn) btn.removeAttribute('disabled'); window.location = cartUrl; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pnav-holder]').forEach(function (holder) {
      var nav = holder.querySelector('[data-pnav]');
      if (!nav) return;
      var links = [].slice.call(nav.querySelectorAll('.pnav__link'));
      if (!links.length) return;

      function headerOffset() {
        var sh = document.querySelector('sticky-header');
        if (sh) {
          var r = sh.getBoundingClientRect();
          if (r.height && r.top <= 1 && r.bottom > 0) return r.bottom;
        }
        return 0;
      }

      function update() {
        var off = headerOffset();
        var top = holder.getBoundingClientRect().top;
        if (top <= off) {
          if (!nav.classList.contains('is-stuck')) {
            holder.style.height = nav.offsetHeight + 'px';
            nav.classList.add('is-stuck');
          }
          nav.style.top = off + 'px';
        } else {
          if (nav.classList.contains('is-stuck')) {
            nav.classList.remove('is-stuck');
            nav.style.top = '';
            holder.style.height = '';
          }
        }
        // lien actif
        var threshold = off + nav.offsetHeight + 16;
        var current = null;
        links.forEach(function (a) {
          var el = document.querySelector(a.getAttribute('data-target'));
          if (el && el.getBoundingClientRect().top - threshold <= 0) current = a;
        });
        links.forEach(function (a) { a.classList.remove('is-active'); });
        if (current) current.classList.add('is-active');
      }

      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var el = document.querySelector(a.getAttribute('data-target'));
          if (!el) return;
          e.preventDefault();
          var off = headerOffset() + nav.offsetHeight + 10;
          var y = window.pageYOffset + el.getBoundingClientRect().top - off;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-articles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rla]').forEach(function (root) {
    var track = root.querySelector('[data-rla-track]');
    if (!track) return;
    var prev = root.querySelector('[data-rla-prev]');
    var next = root.querySelector('[data-rla-next]');
    function step() {
      var card = track.querySelector('.rla__item');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var PEEK = 38;
    function initPeek() {
      var c = track.querySelector('.rla__item');
      if (!c) return;
      if (track.scrollWidth > track.clientWidth + 4) {
        var w = c.getBoundingClientRect().width;
        var pb = track.style.scrollBehavior; track.style.scrollBehavior = 'auto';
        track.scrollLeft = Math.max(0, Math.round(w - PEEK));
        track.style.scrollBehavior = pb || '';
      }
    }
    if ('requestAnimationFrame' in window) { requestAnimationFrame(initPeek); }
    setTimeout(initPeek, 200); setTimeout(initPeek, 600);
    window.addEventListener('load', initPeek);
    window.addEventListener('resize', initPeek);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-footer"]) return;
  try {
    
  (function () {
    function rootUrl() {
      var el = document.querySelector('[data-root-url]');
      return (el && el.getAttribute('data-root-url')) || '/';
    }
    // Panier vide : « Continuer mes achats » -> accueil (page panier + tiroir)
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (!a.closest('.is-empty')) return;
      if (a.classList.contains('button') || a.classList.contains('underlined-link')) {
        e.preventDefault();
        window.location.href = rootUrl();
      }
    });
  })();

  // Vignettes produit dans le tiroir de menu (additif)
  (function () {
    function addThumbs() {
      var data = document.getElementById('menu-thumbs-data');
      if (!data) return;
      var map;
      try { map = JSON.parse(data.textContent); } catch (e) { return; }
      var links = document.querySelectorAll('.menu-drawer__menu-item[href*="/products/"]');
      Array.prototype.forEach.call(links, function (a) {
        if (a.querySelector('.menu-thumb')) return;
        var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (!m) return;
        var url = map[m[1]];
        if (!url) return;
        var img = document.createElement('img');
        img.src = url; img.alt = ''; img.loading = 'lazy'; img.className = 'menu-thumb';
        a.insertBefore(img, a.firstChild);
      });
    }
    if (document.readyState !== 'loading') addThumbs();
    else document.addEventListener('DOMContentLoaded', addThumbs);
  })();

  // Icônes à gauche des liens non-produits du tiroir de menu (additif)
  (function () {
    var ICONS = {
      '/blogs/': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 7v14"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/></svg>',
      '/pages/programme-ambassadeur': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
      '/apps/track123': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/><path d="m7.5 4.27 9 5.15"/></svg>',
      '/pages/faq': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>',
      '/pages/contact': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>',
      '/account': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>'
    };
    function addIcons() {
      var links = document.querySelectorAll('.menu-drawer__menu-item');
      Array.prototype.forEach.call(links, function (a) {
        if (a.querySelector('.menu-ico') || a.querySelector('.menu-thumb')) return;
        var href = a.getAttribute('href') || '';
        var svg = null;
        for (var key in ICONS) { if (href.indexOf(key) !== -1) { svg = ICONS[key]; break; } }
        if (!svg) return;
        var span = document.createElement('span');
        span.className = 'menu-ico';
        span.setAttribute('aria-hidden', 'true');
        span.innerHTML = svg;
        a.insertBefore(span, a.firstChild);
      });
    }
    if (document.readyState !== 'loading') addIcons();
    else document.addEventListener('DOMContentLoaded', addIcons);
  })();

  // Traits séparateurs fins après certains items du tiroir de menu (additif)
  (function () {
    var SEP_AFTER = ['/pages/faq', '/apps/track123', '/pages/programme-ambassadeur'];
    function addSeps() {
      SEP_AFTER.forEach(function (h) {
        var a = document.querySelector('.menu-drawer__menu-item[href$="' + h + '"]');
        if (!a) return;
        var li = a.closest ? a.closest('li') : null;
        if (li) li.classList.add('menu-sep');
      });
    }
    function sizeSeps() {
      var seps = document.querySelectorAll('.menu-drawer li.menu-sep');
      if (!seps.length) return;
      // Longueur de référence = largeur du lien « Stick repulpant bio-collagène » sur UNE seule ligne
      var ref = document.querySelector('.menu-drawer__menu-item[href$="/products/stick-repulpant-bio-collagene"]');
      if (!ref) return;
      var iconEl = ref.querySelector('.menu-ico, .menu-thumb');
      var iconRect = (iconEl || ref).getBoundingClientRect();
      var iconLeft = iconRect.left;
      var iconW = iconEl ? iconRect.width : 0;
      var cs = getComputedStyle(ref);
      var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 10;
      // Mesure du texte en une seule ligne via un clone masqué
      var span = document.createElement('span');
      span.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:nowrap;';
      span.style.fontFamily = cs.fontFamily;
      span.style.fontSize = cs.fontSize;
      span.style.fontWeight = cs.fontWeight;
      span.style.letterSpacing = cs.letterSpacing;
      span.style.textTransform = cs.textTransform;
      span.textContent = (ref.textContent || '').replace(/\s+/g, ' ').trim();
      document.body.appendChild(span);
      var textW = span.getBoundingClientRect().width;
      document.body.removeChild(span);
      if (textW <= 0) return;
      var w = iconW + gap + textW;
      Array.prototype.forEach.call(seps, function (li) {
        var lir = li.getBoundingClientRect();
        li.style.setProperty('--sep-x', (iconLeft - lir.left) + 'px');
        li.style.setProperty('--sep-w', w + 'px');
      });
    }
    function init() {
      addSeps();
      sizeSeps();
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(sizeSeps); }
      requestAnimationFrame(sizeSeps);
      setTimeout(sizeSeps, 400);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', sizeSeps);
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sizeSeps, 200); });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ----- Affichage de la barre selon le scroll ----- */
    function initBar(bar) {
      if (bar.dataset.stickyReady === 'true') return;
      bar.dataset.stickyReady = 'true';

      // Référence = bloc « Garanties & satisfaction » ; repli = bouton d'achat principal.
      var reference = null;
      var summaries = document.querySelectorAll('summary');
      for (var s = 0; s < summaries.length; s++) {
        var t = (summaries[s].textContent || '').toLowerCase();
        if (t.indexOf('garantie') > -1 || t.indexOf('satisfaction') > -1) {
          reference = summaries[s].closest('.product-acc') || summaries[s];
          break;
        }
      }
      if (!reference) {
        var submits = document.querySelectorAll('.product-form__submit');
        for (var i = 0; i < submits.length; i++) {
          if (!submits[i].closest('.sticky-atc-modal')) { reference = submits[i]; break; }
        }
      }

      function show() { bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false'); }
      function hide() { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); }

      // La barre n'apparaît qu'une fois la référence DÉPASSÉE (sortie par le haut).
      function evaluate() {
        if (!reference) return;
        if (reference.getBoundingClientRect().bottom <= 0) { show(); } else { hide(); }
      }

      if (reference && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          var e = entries[0];
          if (e.isIntersecting) { hide(); }
          else if (e.boundingClientRect.top < 0) { show(); }
          else { hide(); }
        }, { threshold: 0 });
        observer.observe(reference);
        evaluate();
      } else {
        window.addEventListener('scroll', evaluate, { passive: true });
        evaluate();
      }
    }

    /* ----- Popup ----- */
    function initModal() {
      var modal = document.querySelector('[data-sticky-modal]');
      if (!modal || modal.dataset.ready === 'true') return;
      modal.dataset.ready = 'true';

      var packs = modal.querySelectorAll('[data-sticky-packs] .sticky-atc-modal__pack');
      var idInput = modal.querySelector('[data-sticky-variant-input]');
      var dialog = modal.querySelector('.sticky-atc-modal__dialog');
      var lastFocus = null;

      function selectPack(btn) {
        if (btn.disabled) return;
        if (idInput) idInput.value = btn.getAttribute('data-variant-id');
        for (var j = 0; j < packs.length; j++) {
          packs[j].classList.remove('is-active');
          packs[j].setAttribute('aria-pressed', 'false');
        }
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      }

      // Pré-sélection selon la variante choisie sur la fiche (si dispo).
      function presyncFromMain() {
        if (!packs.length) return;
        var mainId = null;
        var inputs = document.querySelectorAll('input[name="id"]');
        for (var k = 0; k < inputs.length; k++) {
          if (!inputs[k].closest('.sticky-atc-modal')) { mainId = inputs[k].value; break; }
        }
        if (!mainId) return;
        for (var p = 0; p < packs.length; p++) {
          if (packs[p].getAttribute('data-variant-id') === String(mainId)) { selectPack(packs[p]); break; }
        }
      }

      function openModal() {
        lastFocus = document.activeElement;
        presyncFromMain();
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var active = modal.querySelector('.sticky-atc-modal__pack.is-active') || modal.querySelector('.sticky-atc-modal__add');
        if (active) { try { active.focus(); } catch (e) {} }
      }
      function closeModal() {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
      }

      var openers = document.querySelectorAll('[data-sticky-open]');
      for (var o = 0; o < openers.length; o++) {
        openers[o].addEventListener('click', openModal);
      }
      var closers = modal.querySelectorAll('[data-sticky-close]');
      for (var c = 0; c < closers.length; c++) {
        closers[c].addEventListener('click', closeModal);
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
      for (var q = 0; q < packs.length; q++) {
        packs[q].addEventListener('click', function () { selectPack(this); });
      }

      // Fermer la popup quand le panier (tiroir / notif) s'ouvre après l'ajout.
      var cartUI = document.querySelector('cart-drawer, cart-notification');
      if (cartUI && 'MutationObserver' in window) {
        new MutationObserver(function () {
          if (!modal.hidden && cartUI.classList.contains('active')) closeModal();
        }).observe(cartUI, { attributes: true, attributeFilter: ['class'] });
      }
    }

    function initAll(root) {
      var scope = root || document;
      var bars = scope.querySelectorAll('[data-sticky-atc]');
      for (var i = 0; i < bars.length; i++) { initBar(bars[i]); }
      initModal();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-ba"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.tbReady === 'true') return;
      root.dataset.tbReady = 'true';

      var track = root.querySelector('[data-tb-track]');
      var prev = root.querySelector('[data-tb-prev]');
      var next = root.querySelector('[data-tb-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.testimonials-ba__card');
        if (!card) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      // Boucle infinie : on duplique les cartes une seule fois
      var loopW = 0;
      (function setupLoop() {
        if (track.scrollWidth <= track.clientWidth + 2) return;
        var kids = Array.prototype.slice.call(track.children);
        for (var i = 0; i < kids.length; i++) {
          var c = kids[i].cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.classList.add('tb-clone');
          track.appendChild(c);
        }
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        loopW = track.scrollWidth / 2;
      })();
      window.addEventListener('load', function () { if (loopW > 0) { loopW = track.scrollWidth / 2; } }, { passive: true });

      function wrap() {
        if (loopW <= 0) return;
        if (track.scrollLeft >= loopW) { track.scrollLeft = track.scrollLeft - loopW; }
        else if (track.scrollLeft < 0) { track.scrollLeft = track.scrollLeft + loopW; }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          if (loopW > 0 && track.scrollLeft <= 0) { track.scrollLeft += loopW; }
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      // Défilement continu : déroule sans jamais revenir en arrière (rebouclage transparent)
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var SPEED = 0.5;
      var paused = false, raf = null;
      function tick() {
        if (!paused && loopW > 0) {
          track.scrollLeft += SPEED;
          if (track.scrollLeft >= loopW) { track.scrollLeft -= loopW; }
        }
        raf = requestAnimationFrame(tick);
      }
      // flèches / swipe : rebouclage transparent uniquement quand l'auto est en pause
      var wrapT = null;
      track.addEventListener('scroll', function () {
        if (!paused || wrapT) return;
        wrapT = setTimeout(function () { wrapT = null; wrap(); }, 130);
      }, { passive: true });
      function pause() { paused = true; }
      function resume() { paused = false; }
      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('touchend', function () { setTimeout(resume, 2500); }, { passive: true });
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var timer = null;
      if (!reduce && loopW > 0) {
        if (isMobile) {
          timer = setInterval(function () {
            if (paused) return;
            track.scrollBy({ left: step(), behavior: 'smooth' });
            setTimeout(function () { if (track.scrollLeft >= loopW - 1) { track.scrollLeft -= loopW; } }, 650);
          }, 5000);
        } else {
          raf = requestAnimationFrame(tick);
        }
      }
    }

    function initAll(root) {
      var scope = root || document;
      var carousels = scope.querySelectorAll('[data-testimonials]');
      for (var i = 0; i < carousels.length; i++) {
        initCarousel(carousels[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Boucle infinie calquée sur la section avant/après (sans auto-défilement).
    function initCarousel(root) {
      if (root.dataset.ugcReady === 'true') return;
      root.dataset.ugcReady = 'true';

      var track = root.querySelector('[data-ugc-track]');
      if (!track) return;
      var prev = root.querySelector('[data-ugc-prev]');
      var next = root.querySelector('[data-ugc-next]');

      function step() {
        var c = track.querySelector('.ugc__item');
        if (!c) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return c.getBoundingClientRect().width + gap;
      }

      // Lecture vidéo en délégation (fonctionne aussi sur les clones).
      // Tap = lecture avec son ; re-tap = pause.
      function pauseAll(except) {
        track.querySelectorAll('[data-ugc-video]').forEach(function (o) {
          if (o !== except) { o.pause(); o.muted = true; var c = o.closest('.ugc__card'); if (c) c.classList.remove('is-playing'); }
        });
      }
      track.addEventListener('click', function (e) {
        var card = e.target.closest('.ugc__card');
        if (!card || !track.contains(card)) return;
        var v = card.querySelector('[data-ugc-video]');
        if (!v) return;
        if (v.paused) {
          pauseAll(v);
          v.muted = false;
          v.play().catch(function () { v.muted = true; v.play().catch(function () {}); });
          card.classList.add('is-playing');
        } else {
          v.pause();
          card.classList.remove('is-playing');
        }
      });

      var PEEK = 15;
      // Boucle infinie : on duplique les cartes une seule fois
      var loopW = 0;
      (function setupLoop() {
        if (track.scrollWidth <= track.clientWidth + 2) return;
        var kids = Array.prototype.slice.call(track.children);
        for (var i = 0; i < kids.length; i++) {
          var c = kids[i].cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.classList.add('ugc-clone');
          var cv = c.querySelector('[data-ugc-video]'); if (cv) cv.preload = 'none';
          track.appendChild(c);
        }
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.style.justifyContent = 'flex-start';
        loopW = track.scrollWidth / 2;
        var first = track.querySelector('.ugc__item');
        var w = first ? first.getBoundingClientRect().width : 0;
        track.scrollLeft = Math.max(0, Math.round(w - PEEK));
      })();
      window.addEventListener('load', function () { if (loopW > 0) { loopW = track.scrollWidth / 2; } }, { passive: true });

      function wrap() {
        if (loopW <= 0) return;
        if (track.scrollLeft >= loopW) { track.scrollLeft = track.scrollLeft - loopW; }
        else if (track.scrollLeft < 0) { track.scrollLeft = track.scrollLeft + loopW; }
      }

      if (prev) prev.addEventListener('click', function () {
        if (loopW > 0 && track.scrollLeft < step() + 4) { track.scrollLeft += loopW; }
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      var wrapT = null;
      track.addEventListener('scroll', function () {
        if (wrapT) return;
        wrapT = setTimeout(function () { wrapT = null; wrap(); }, 130);
      }, { passive: true });
    }

    function initAll(root) {
      var scope = root || document;
      var c = scope.querySelectorAll('[data-ugc]');
      for (var i = 0; i < c.length; i++) { initCarousel(c[i]); }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
